import { exportSceneToGLTF, exportToJson } from "../helpers";
import { getURDFFromURL } from "../robotFunctions/loaderHelper";
import { Button, TextInput, FileUploader, Checkbox } from "../ui/pageElements";
import { loadJsonURL, loadJsonFile } from "../robotFunctions/loaderHelper";
// import { toggleTop, toggleBottom, toggleLeft, toggleRight } from '../sceneInit'

/*
    Interface for loading and saving data in the scene
*/
export class LoadSaveInterface {
    constructor(interfaces) {
        this.interfaces = interfaces;

        // button for uploading json scenes locally
        this.jsonLoader = new FileUploader("Upload JSON Scene", "topBlock", [".json"], false);
        this.jsonLoader.setToolTip(this.interfaces.tooltips.uploadJson, "topToolTip");
        this.jsonLoader.fileUploader.onchange = () => {
            if (this.jsonLoader.getFiles().length > 0) {
                loadJsonFile(this.jsonLoader.getFiles()[0], (text) => {
                    let jsonObj = JSON.parse(text);
                    this.loadJson(jsonObj);
                });
            }
        }

        // input text for entering the url of a json link
        this.jsonURLInput = new TextInput("JSON URL", "topBlock");
        this.jsonURLInput.setToolTip(this.interfaces.tooltips.jsonLink, "topToolTip");

        // button for loading json file from url inputted in the input text
        this.loadJsonButton = new Button("Load JSON URL", "topBlock", () => {
            loadJsonURL(this.jsonURLInput.textInput.value, (text) => {
                let jsonObj = JSON.parse(text);
                this.loadJson(jsonObj);
            });
        })
        this.loadJsonButton.setToolTip(this.interfaces.tooltips.jsonLinkButton, "topToolTip");

        // button for setting 'view only' mode
        this.viewOnlyToggle = new Checkbox("View Only", "topBlock", false)

        // button for saving the scene as a json file and downloading it
        this.saveJsonButton = new Button("Save Scene As Json", "topBlock", () => {
            exportToJson(this.saveScene(true), "Scene");
        })
        this.saveJsonButton.setToolTip(this.interfaces.tooltips.jsonSave, "topToolTip");

        // button for generating a querystring link to the file, NOT USED ANYMORE, COMMENTED OUT FOR NOW
        this.linkButton = new Button("Test Button", "topBlock", () => {
            this.testFunction();
        })
        // this.linkButton.setToolTip(this.interfaces.tooltips.generateLink, "topToolTip");

        // button for loading in a scene using querystring, NOT USED ANYMORE, COMMENTED OUT FOR NOW
        // this.linkText = new TextInput("Scene Link", "topBlock")
        // this.linkText.setToolTip(this.interfaces.tooltips.sceneLink, "topToolTip");

        // button for exporting a gltf of the scene and downloading it
        this.exportGLTFButton = new Button("Export to GLTF", "topBlock", () => {
            exportSceneToGLTF(this.interfaces.scene);
        })
    }

    // test link
    loadQueryString(params) {
        let jsonURL = params.jsonLink;
        let robotFilesParams = params.robotFiles;
        // json scene exists
        if (jsonURL) {
            loadJsonURL(jsonURL, (text) => {
                let jsonObj = JSON.parse(text);
                this.loadJson(jsonObj);
            });
        }
        // only if there is no json scene to load
        // else if (robotFilesParams) {
        //     let robotFiles = robotFilesParams.split(",");
        //     let recursiveLoad = (robotFiles, index) => {
        //         let currFile = robotFiles[index];
        //         index++;
        //         if (currFile) {
        //             getURDFFromURL(currFile, (blob) => {
        //                 this.interfaces.robot.loadRobot(URL.createObjectURL(blob), currFile, () => {
        //                     recursiveLoad(robotFiles, index);
        //                 })
        //             });
        //         } else {
        //             let animationMapParams = params.animationMap;
        //             let animationFilesParams = params.animationFiles;
        //             if (animationMapParams && animationFilesParams) {
        //                 let animationMap = animationMapParams.split(",").map(index => Number(index));
        //                 let animationFiles = animationFilesParams.split(",");
        //                 this.loadAnimations(animationFiles, animationMap);
        //             }

        //             let configsMapParams = params.configsMap;
        //             let configsParams = params.configs;
        //             if (configsMapParams && configsParams) {
        //                 let configsMap = configsMapParams.split(",").map(index => Number(index));
        //                 let configs = configsParams.split(",");
        //                 this.setRobotPositions(configs, configsMap);
        //             }

        //             let robotSettingsParams = params.robotSettings;
        //             if (robotSettingsParams) {
        //                 let robotSettings = robotSettingsParams.split(",");
        //                 this.setRobotSettings(robotSettings);
        //             }
        //         }
        //     }
        //     recursiveLoad(robotFiles, 0);
        // }
    }

    loadJson(jsonObj) {
        console.log(jsonObj);
        let robotFiles = jsonObj.robotFiles;
        if (!robotFiles) {
            console.log("No robot files detected");
            return;
        }
        let recursiveLoad = (robotFiles, index) => {
            let currFile = robotFiles[index];
            index++;
            // loads all robots in before anything else
            if (currFile) {
                getURDFFromURL(currFile, (blob) => {
                    this.interfaces.robot.loadRobot(URL.createObjectURL(blob), currFile, () => {
                        recursiveLoad(robotFiles, index);
                    })
                });
            } else {
                // load and set robot motions
                if (jsonObj.animationMap && jsonObj.animationURLs) {
                    // if there are lines to generate
                    if (jsonObj.linesData) {
                        this.loadAnimations(jsonObj.animationURLs, jsonObj.animationMap, () => {
                            this.loadLines(jsonObj.linesData);
                            if(jsonObj.generalSettings) {
                                console.log(jsonObj.generalSettings.selectedRobot)
                                this.interfaces.robot.setRobot(jsonObj.generalSettings.selectedRobot)
                            }
                            if(jsonObj.viewOnly) {
                                this.interfaces.animation.simplifyBar();
                            }
                        });
                    // if not lines
                    } else {
                        this.loadAnimations(jsonObj.animationURLs, jsonObj.animationMap, () => {
                            if(jsonObj.generalSettings) {
                                this.interfaces.robot.setRobot(jsonObj.generalSettings.selectedRobot)
                            }
                            if(jsonObj.viewOnly) {
                                this.interfaces.animation.simplifyBar();
                            }
                        });
                    }
                }
                // set robot positions
                if (jsonObj.configsMap && jsonObj.configs) {
                    this.setRobotPositions(jsonObj.configs, jsonObj.configsMap);
                }
                // set robot settings
                if (jsonObj.robotSettings) {
                    let settingsArr = [];
                    jsonObj.robotSettings.forEach(settings => {
                        let groupSettings = []
                        settings.forEach(setting => {
                            groupSettings.push("" + setting);
                        })
                        settingsArr.push(groupSettings)
                    })
                    this.setRobotSettings(settingsArr);
                }
                // set camera views
                if (jsonObj.cameraViews) {
                    this.loadCameraViews(jsonObj.cameraViews);
                } // general settings
                if (jsonObj.generalSettings) {
                    if(jsonObj.generalSettings.tabStates && !jsonObj.viewOnly) {
                        let tabStates = jsonObj.generalSettings.tabStates
                        if (!tabStates.top) {
                            this.interfaces.tabs.controls.top();
                        }
                        if (!tabStates.bottom) {
                            this.interfaces.tabs.controls.bottom();
                        }
                        if (!tabStates.left) {
                            this.interfaces.tabs.controls.left();
                        }
                        if (!tabStates.right) {
                            this.interfaces.tabs.controls.right();
                        }
                    }
                    this.interfaces.cameraInterface.updateControls(jsonObj.generalSettings.camera)
                    this.interfaces.robot.setClickSelect(jsonObj.generalSettings.clickSelect)
                }
                // if json is set to view only
                if (jsonObj.viewOnly) {
                    this.interfaces.tabs.controls.top();
                    this.interfaces.tabs.controls.left();
                    this.interfaces.tabs.controls.right();
                    this.interfaces.tabs.controls.removeUIControl();
                }
            }
        }
        recursiveLoad(robotFiles, 0);
    }

    loadAnimations(files, map, afterFunction = () => { }) {
        let allRobots = this.interfaces.robot.getAllRobots();
        let loadAnimationsRecurisve = (fileIndex) => {
            if (fileIndex < files.length) {
                let total = 0;
                let robotIndex = 0;
                for (let i = 0; i < map.length; i++) {
                    total += map[i];
                    if (total <= fileIndex) {
                        robotIndex++;
                    }
                }
                this.interfaces.robot.setRobot(allRobots[robotIndex].robotName);
                this.interfaces.animation.loadAnimation(files[fileIndex], () => {
                    fileIndex++;
                    loadAnimationsRecurisve(fileIndex);
                });
            } else {
                this.interfaces.robot.setRobot(allRobots[0].robotName);
                afterFunction();
                console.log("finish loading motions");
            }
        }

        loadAnimationsRecurisve(0, 0, 0);
    }

    setRobotPositions(robotPositions, map) {
        let allRobotGroups = this.interfaces.robot.getAllRobotGroups();
        let mapIndex = 0;
        let start = 0;
        let end = map[mapIndex];
        allRobotGroups.forEach(group => {
            group.jointInterface.setJoints(robotPositions.slice(start, end))
            start += map[mapIndex];
            mapIndex++;
            end += map[mapIndex];
        })
    }

    setRobotSettings(robotSettings) {
        let index = 0;
        let allRobotGroups = this.interfaces.robot.getAllRobotGroups();
        allRobotGroups.forEach(group => {
            let settings = {
                robotVisible: robotSettings[index][0],
                eeVisible: robotSettings[index][1],
                opacity: robotSettings[index][2],
                hoverable: robotSettings[index][3],
                endEffector: robotSettings[index][4],
                parallelMotions: robotSettings[index][5] ? robotSettings[index][5].trim().split(',') : [],
                isParallelMotionShown: robotSettings[index][6]=="true"
            }
            group.setSettings(settings);
            index += 1;
        })
    }

    loadLines(linesData) {
        let allRobotGroups = this.interfaces.robot.getAllRobotGroups();
        allRobotGroups.forEach(robotGroup => {
            linesData.forEach(lineGroup => {
                if (lineGroup.robotName == robotGroup.robot.robotName) {
                    this.interfaces.robot.setRobot(lineGroup.robotName);
                    robotGroup.animationInterface.prerenderLine(lineGroup.motionName)
                }
            })
        })
        this.interfaces.robot.setRobot(allRobotGroups[0].robot.robotName);
    }

    loadBookmarks(bookmarksData) {
        let allRobotGroups = this.interfaces.robot.getAllRobotGroups();
        allRobotGroups.forEach(robotGroup => {

        })
    }

    loadCameraViews(cameraViewData) {
        cameraViewData.forEach(view => {
            this.interfaces.cameraInterface.addCameraView(view);
        })
    }

    // generate link, decide if query string or json file
    saveScene(isJson) {
        let link = window.location.href.split('?')[0];
        let allRobotGroups = this.interfaces.robot.getAllRobotGroups();
        let animationURLs = [];
        let animationMap = [];
        let configs = [];
        let configsMap = [];
        let robotSettings = [];

        if (allRobotGroups.length > 0) {
            link += "?robotFiles=" + allRobotGroups.filter(group => group.url != null).map(group => group.url).join(",");
        }
        allRobotGroups.filter(group => group.url != null).forEach(group => {
            let urls = group.animationInterface.getAnimationURLs();
            urls.forEach(url => {
                animationURLs.push(url);
            });
            animationMap.push(urls.length);
            let config = group.getJointConfigs();
            config.forEach(value => {
                configs.push(value);
            })
            configsMap.push(config.length);
            robotSettings.push(Object.values(group.getSettings()));
        })
        link += "&animationFiles=" + animationURLs.join(",") + "&animationMap=" + animationMap.join(",")
            + "&configs=" + configs.join(",") + "&configsMap=" + configsMap.join(",") + "&robotSettings=" + robotSettings.join(",");
        link = link.replace(/ /g, "%20");


        let bookmarks = [];
        allRobotGroups.forEach(group => {
            bookmarks.push({
                robotName: group.robot.robotName,
                bookmarks: group.animationInterface.getBookmarksData()
            })
        })

        let generalSettings = {
            camera: {
                cameraPos: this.interfaces.controls.object.position.clone(),
                cameraLookAt: this.interfaces.controls.target.clone(),
                cameraZoom: this.interfaces.controls.object.zoom
            },
            tabStates: this.interfaces.tabs.state,
            selectedRobot: this.interfaces.robot.getSelectedRobot().robotName,
            clickSelect: this.interfaces.robot.getClickSelectSetting()
        }

        let jsonData = {
            robotFiles: allRobotGroups.map(group => group.url),
            animationURLs: animationURLs,
            animationMap: animationMap,
            configs: configs,
            configsMap: configsMap,
            robotSettings: robotSettings,
            linesData: this.interfaces.lines.getLinesJSON(),
            bookmarks: bookmarks,
            cameraViews: this.interfaces.cameraInterface.getCameraViewData(),
            generalSettings: generalSettings,
            viewOnly: this.viewOnlyToggle.checkbox.checked
        }
        let myJSON = JSON.stringify(jsonData);
        if (isJson) {
            link = myJSON;
        }
        return link;
    }

    testFunction() {
        console.log("test function")
        console.log(this.interfaces.robot.getSelectedRobot())
    }
}